import {
    CREATE_REFERRAL_FAILURE,
    CREATE_REFERRAL_REQUEST,
    CREATE_REFERRAL_SUCCESS,
    ReferralActionTypes,
    ReferralState
} from '../types/referral.types';

const initialState: ReferralState = {
    loading: false,
    referrals: [],
    totalReferrals: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
    error: null
};

const referralReducer = (
    state = initialState,
    action: ReferralActionTypes
): ReferralState => {
    switch (action.type) {
        case CREATE_REFERRAL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case CREATE_REFERRAL_SUCCESS:
            return {
                ...state,
                loading: false,
                // Append the new referral to the list
                referrals: [action.payload, ...state.referrals],
                error: null
            };
        case CREATE_REFERRAL_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default referralReducer;
